// when this value, navi usage should be blank display (used when null usage happened, to differentiate from 0% usage)
export const naviUsageBlankVal = -1.0;
